export const loginTypes = {
  INIT_SESSION_LOGIN: "INIT_SESSION_LOGIN",
  SET_INFO_LOGIN: "SET_INFO_LOGIN",
  ERROR_INIT_SESSION_LOGIN: "ERROR_INIT_SESSION_LOGIN",
  CLOSE_SESSION_LOGIN: "CLOSE_SESSION_LOGIN",
  CLEAR_ERROR_LOGIN: "CLEAR_ERROR_LOGIN",
  SET_USERNAME_LOGIN: "SET_USERNAME_LOGIN",
  SET_PASSWORD_LOGIN: "SET_PASSWORD_LOGIN",
  CLEAR_FIELDS_LOGIN: "CLEAR_FIELDS_LOGIN",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  // NEW_PRINTER: "NEW_PRINTER",
  // EDIT_PRINTER: "EDIT_PRINTER",
  // DELETE_PRINTER: "DELETE_PRINTER",
  SET_INACTIVE_SESSION: "SET_INACTIVE_SESSION",
  SET_MS_URL: "SET_MS_URL",
  SEND_MS_DATA: "SEND_MS_DATA",
  UPDATE_LOGIN_INFO: "UPDATE_LOGIN_INFO"
};
